import React from 'react';

const IconeCodigoBarras = ({ exibirCirculo, color, className }) => {
    const size = exibirCirculo ? 28 : 16;
    const x = exibirCirculo ? 6 : 0;
    const y = exibirCirculo ? 6 : 0;

    return (
        <svg
            viewBox={`0 0 ${size} ${size}`}
            width={size}
            height={size}
            stroke={color || "currentColor"}
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {exibirCirculo && <circle cx={size / 2} cy={size / 2} r={(size / 2) - 1}></circle>}
            <line x1={x + 0} x2={x + 0} y1={y + 3} y2={y + 13}></line>
            <line x1={x + 4} x2={x + 4} y1={y + 3} y2={y + 11}></line>
            <line x1={x + 8} x2={x + 8} y1={y + 3} y2={y + 13}></line>
            <line x1={x + 12} x2={x + 12} y1={y + 3} y2={y + 11}></line>
            <line x1={x + 16} x2={x + 16} y1={y + 3} y2={y + 13}></line>
        </svg>
    );
};

export default IconeCodigoBarras;